// extracted by mini-css-extract-plugin
export var primitiveLabel = "_v7-0";